module.exports = __webpack_public_path__ + "img/ican.9c3315a4.png";